import smallLogo from './logo.png';
import logo from './logo-180x180.png';
import largeLogo from './logo-256x256.png';
import user from './user.png';
import mailBox from './mail-box.jpg';
import key from './key.png';

export { logo, smallLogo, largeLogo, user, mailBox, key };
